import { render, staticRenderFns } from "./ManutencaoRfiPrincipal.vue?vue&type=template&id=1743e46c&"
import script from "./ManutencaoRfiPrincipal.vue?vue&type=script&lang=js&"
export * from "./ManutencaoRfiPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports